var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { maxLength, required, useForm, useModel } from '@veeam/core';
import styled from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../StackView";
import { FormLayout } from "../FormLayout";
import { TextField } from "../fields";
import { Button } from "../Button";
import { ErrorMessage } from "../ErrorMessage";
import { useAutoFocus, useLoginFormSubmit } from "./hooks";
import { Spinner } from "../Spinner";
import { Notification, NOTIFICATION_STATUS } from "../Notification";
import { CONTROL_SIZE } from "../common/public";
var DEFAULT_TEXTS = {
    placeholderMFACode: 'Code',
    actionLogIn: 'Log in',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    warningMFA: 'Multi-factor authentication is enabled for this account. To log in, enter the verification code sent to your trusted device.'
};
var LoginButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: 112px;\n"], ["\n    min-width: 112px;\n"])));
export function LoginMFA(_a) {
    var loading = _a.loading, logIn = _a.logIn, busyModel = _a.busyModel, customTexts = _a.texts;
    var texts = Object.assign({}, DEFAULT_TEXTS, customTexts);
    var inputRef = useAutoFocus();
    var form = useForm({ code: '' }, {
        validationSchema: {
            code: [required(texts.errorRequired), maxLength(255, texts.errorMaxLength)]
        }
    });
    var internalLoading = useModel(busyModel).value.loading;
    var _b = useLoginFormSubmit({ form: form, handler: logIn, busyModel: busyModel }), submit = _b.submit, errorHighlight = _b.errorHighlight, fieldFocusHandler = _b.fieldFocusHandler, keyDownHandler = _b.keyDownHandler, hasError = _b.hasError, error = _b.error;
    loading = loading || internalLoading;
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.s, onKeyDown: keyDownHandler },
        hasError && React.createElement(ErrorMessage, null, error),
        React.createElement(Notification, { status: NOTIFICATION_STATUS.info }, texts.warningMFA),
        React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.m },
            React.createElement(FormLayout, { disabled: loading },
                React.createElement(TextField, { field: form.fields.code, controlRef: inputRef, placeholder: texts.placeholderMFACode, size: CONTROL_SIZE.full, hasError: errorHighlight, onFocus: fieldFocusHandler })),
            React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center },
                React.createElement(LoginButton, { onClick: submit, disabled: loading }, texts.actionLogIn),
                loading && React.createElement(Spinner, null)))));
}
var templateObject_1;
//# sourceMappingURL=LoginMFA.js.map